import { useScrollReveal } from '../../../hooks/useScrollReveal';

const avantages = [
  {
    icon: 'ri-swap-line',
    title: 'Flexibilité totale',
    description: 'Augmentez ou réduisez votre équipe commerciale en quelques jours. Adaptez-vous à votre saisonnalité sans contrainte.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Démarrage en 48h',
    description: "Nos équipes sont formées, équipées et opérationnelles. Vous briefez vendredi, on prospecte lundi. Vraiment.",
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Zéro charge patronale',
    description: 'Fini les charges sociales, la mutuelle, les congés, les arrêts maladie. Vous ne payez que la performance.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Résultats mesurables',
    description: 'KPIs précis, reporting hebdomadaire, dashboards en temps réel. Vous savez exactement ce qui se passe sur votre pipe.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Profils expérimentés',
    description: 'Uniquement des commerciaux avec 3+ ans d\'expérience, sélectionnés sur votre secteur. On ne fait pas dans la quantité.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Focus sur votre core',
    description: 'Pendant qu\'on prospecte pour vous, vous gérez la production, les clients et la croissance. Rôles bien définis.',
  },
];

export default function Avantages() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section id="avantages" className="bg-[#F9F9F9] py-24 lg:py-32">
      <div ref={ref} className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-block text-[#6ECFA0] text-sm font-bold uppercase tracking-widest mb-4">
            Pourquoi FlexForce
          </span>
          <h2 className="text-4xl lg:text-5xl font-black text-[#0A0A0A] leading-tight">
            Tout ce qu&apos;un commercial interne ne peut pas vous offrir
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {avantages.map((item, i) => (
            <div
              key={item.title}
              className={`group bg-[#0A0A0A] rounded-2xl p-8 hover:-translate-y-1 transition-all duration-500 cursor-default ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-gradient-to-br from-[#6ECFA0] to-[#8DDAB5] mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${item.icon} text-2xl text-white`} />
              </div>

              <h3 className="text-lg font-black text-white mb-3">{item.title}</h3>
              <p className="text-sm text-white/60 leading-relaxed">{item.description}</p>

              {/* Bottom border animation */}
              <div className="mt-6 h-0.5 w-0 group-hover:w-full bg-[#6ECFA0] transition-all duration-500 rounded-full" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
